/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import React from 'react'

/* global WorldWind */

export default class TampereCombinedDetailedPlanMap extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Combined Detailed Plan Map",
            service: "https://geodata.tampere.fi/geoserver/wms?service=WMS",
            version: "1.3.0",
            layerNames: "maankaytto:KAYTTOTARKOITUSALUEET",
        };

        super(cfg);

        this.urlBuilder.transparent = true;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                " Open Data Tampere",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Ajantasa-asemakaavan käyttötarkoitusalueilla osoitetaan alueen pääasiallinen käyttötarkoitus.
                Käyttötarkoitusalueiden väritys perustuu MRL:n asemakaavamerkinnät ja -määräykset oppaaseen.
            </p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://geodata.tampere.fi/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=maankaytto%3AKAYTTOTARKOITUSALUEET"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                Legend
            </p>
        </div>);
    }
}
